import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  inject,
  Input,
  OnDestroy,
} from '@angular/core';
import { GlobalService } from '@base/services/private/global.service';
import { ModalService } from '@base/services/private/modal.service';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { ModalBodyComponent } from '@base/components/private/modals/modal-body/modal-body.component';
import { ModalFooterComponent } from '@base/components/private/modals/modal-footer/modal-footer.component';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import { NotificationService } from '@base/services/notification.service';
import { OrganizerUpdate } from '@base/models/responses/organizer.res';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { finalize, tap } from 'rxjs';

@Component({
  selector: 'app-modal-organizer',
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    forwardRef(() => TranslatePipe),
    NgxSkeletonLoaderComponent,
  ],
  templateUrl: './modal-organizer.component.html',
  styleUrl: './modal-organizer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalOrganizerComponent implements OnDestroy, AfterViewInit {
  private readonly modalSrv = inject(ModalService);
  private readonly globalSrv = inject(GlobalService);
  private readonly notifSrv = inject(NotificationService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  @Input() organizerId = '';
  @Input() modalId = '';

  organizer: OrganizerUpdate | null = null;
  isShowPlaceholder = true;

  ngOnDestroy(): void {
    this.globalSrv.destroyModalRef(this.modalId);
  }

  ngAfterViewInit(): void {
    this.getOrganizerDetail();
  }

  /**
   * close modal
   */
  close(): void {
    this.modalSrv.close(this.modalId);
  }

  /**
   * get detail data of organizer
   * @returns void
   */
  getOrganizerDetail(): void {
    if (!this.organizerId) return;

    this.notifSrv
      .getOrganizerDetail(+this.organizerId)
      .pipe(
        tap(() => {
          this.isShowPlaceholder = true;
        }),
        finalize(() => {
          this.isShowPlaceholder = false;

          setTimeout(() => {
            this.changeDetectorRef.detectChanges();
            this.changeDetectorRef.markForCheck();
          }, 300);
        })
      )
      .subscribe({
        next: (res) => {
          this.organizer = res;
        },
        error: (err) => {
          console.error('error modal organizer: ', err);
        },
      });
  }

  /**
   * open url
   * @returns void
   */
  openUrl(): void {
    window.open(this.organizer?.url, '_blank', 'noopener');
  }
}
